import { Navigate, Route, Routes } from 'react-router-dom';
import ChatPage from './pages/ChatPage';

/**
 * 路由表。原型只有一页；新增页面时在这里加一条，并同步在 specs/ 里补规格。
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ChatPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
